// ============================================================
// 環境設定
// REACT_APP_* 環境変数から読み込み
// 環境別の値は .env.development / .env.staging / .env.production で管理
// ============================================================
export const config = {
    region: process.env.REACT_APP_REGION || '',
    userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
    clientId: process.env.REACT_APP_CLIENT_ID || '',
    appSyncUrl: process.env.REACT_APP_APP_SYNC_URL || '',
    aiLambdaUrl: process.env.REACT_APP_AI_LAMBDA_URL || '',
    cognito: {
        oauth: {
            domain: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN || '',
            redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || '',
            redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT || '',
        },
    },
};

// ============================================================
// Google API設定
// ============================================================
export const gapiConfig = {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
};
